import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, wide = false, testId = "admin-modal" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div data-testid={testId} className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto py-10 px-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative bg-bd-charcoal border border-white/10 w-full ${wide ? "max-w-4xl" : "max-w-2xl"} my-auto`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 sticky top-0 bg-bd-charcoal z-10">
          <h2 className="font-serif text-2xl text-bd-ivory">{title}</h2>
          <button data-testid="modal-close" onClick={onClose} className="text-bd-ivory/50 hover:text-bd-gold p-1"><X size={20} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
